import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/layout/Navbar";
import Footer from "../components/layout/Footer";
import AuthGuard from "../components/AuthGuard";
import { api } from "../api/client";
import { Stethoscope, ChevronRight } from "lucide-react";

const STATUS_TONES = {
    requested: "bg-amber-100 text-amber-800",
    confirmed: "bg-blue-100 text-blue-700",
    in_progress: "bg-violet-100 text-violet-700",
    completed: "bg-emerald-100 text-emerald-700",
    cancelled: "bg-zinc-100 text-zinc-600",
};

const MyConsultations = () => {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        api.get("/consultations").then((r) => setItems(r.data.items || [])).finally(() => setLoading(false));
    }, []);

    return (
        <AuthGuard>
            <div className="min-h-screen bg-white dark:bg-[#0B0B12]">
                <Navbar />
                <main className="mx-auto max-w-3xl px-6 py-10 lg:px-12">
                    <p className="label-uppercase text-zinc-500">Your visits</p>
                    <div className="flex items-end justify-between">
                        <h1 className="text-3xl font-semibold tracking-tight text-zinc-900 dark:text-zinc-50" style={{ letterSpacing: "-0.01em" }}>My consultations</h1>
                        <Link to="/consultations" className="text-sm font-medium text-brand-700 hover:underline">Book new →</Link>
                    </div>
                    {loading ? (<p className="mt-6 text-sm text-zinc-500">Loading…</p>) : items.length === 0 ? (
                        <p className="mt-8 rounded-2xl border border-dashed border-zinc-200 p-10 text-center text-sm text-zinc-500">No consultations yet. <Link to="/consultations" className="text-brand-700 hover:underline">Find a doctor</Link></p>
                    ) : (
                        <ul className="mt-6 space-y-3" data-testid="my-consults-list">
                            {items.map((c) => (
                                <li key={c.id}>
                                    <Link to={`/consultations/${c.id}`} className="flex items-center gap-3 rounded-2xl border border-zinc-100 bg-white p-4 transition-colors hover:border-brand-200 dark:bg-white/[0.03] dark:border-white/10" data-testid={`consult-row-${c.id}`}>
                                        <Stethoscope className="h-5 w-5 text-brand-700" />
                                        <div className="flex-1 min-w-0">
                                            <p className="font-medium text-zinc-900 dark:text-zinc-50">{c.doctor_name}</p>
                                            <p className="text-xs text-zinc-500">{new Date(c.scheduled_at).toLocaleString()} • {c.reason}</p>
                                        </div>
                                        <span className={`whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-medium ${STATUS_TONES[c.status] || "bg-zinc-100 text-zinc-700"}`}>{c.status.replace("_", " ")}</span>
                                        <ChevronRight className="h-4 w-4 text-zinc-400" />
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    )}
                </main>
                <Footer />
            </div>
        </AuthGuard>
    );
};

export default MyConsultations;
